import React, { useState, useContext } from 'react';
import styled from 'styled-components'
import Input from '../../../../../components/input'
import Button from '../../../../../components/button'
import Search from '@material-ui/icons/Search';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { getAccounts } from '../../../../../api';
import { AuthContext } from '../../../../../auth-context'
import { DashboardContext } from '../../../dashboard-context'
import { ErrorMessage } from '../../../../../components/error-message';

const Container = styled.div`
  background: #FFF;
	border-radius: 8px;
	box-shadow: 0px 0px 8px 0px #e1e2e6;
  padding: 24px;
  position: relative;
  width: 100%;

  @media(max-width: 900px) {
    padding: 16px;
  }
`;

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media(max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }
`;

const ButtonContainer = styled.div`
  position: absolute;
  bottom: 24px;
  right: 24px;
  display: flex;
  justify-content: flex-end;

  @media(max-width: 900px) {
    bottom: 16px;
    right: 16px;
  }
`;

const ClearButton = styled(Button)`
  background: none;
  box-shadow: none;
  color: #888;
  margin: 0;

  &:hover {
    background: #EFEFEF;
  }

  &:active {
    background: #DDD;
    box-shadow: none;
    color: #555;
  }
`;

const SelectButton = styled(Button)`
  background:  #EFEFEF;
  box-shadow: none;
  color: #888;
  flex-shrink: 0;
  font-size: 1rem;
  padding: 12px 32px;
  margin: 0;
  width: 153px;
  white-space: nowrap;
  @media(max-width: 900px) {
    padding: 12px;
    width: 120px;
  }

  &:hover {
    background: #EFEFEF;
  }

  &:active {
    background: #DDD;
    box-shadow: none;
    color: #555;
  }

`;

const SearchBar = styled.div`
  display: flex;
`;

const SearchInput = styled(Input)`
  margin: 0 0 0 16px;
`;


const SearchUser = (props) => {
  const [error, setError] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null);
  const { user, updateUser } = useContext(AuthContext);
  const { teamSearch, setTeamSearch } = useContext(DashboardContext);

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  }

  const clearSearch = (e) => {
    e.preventDefault()
    getAccounts(user.id).then((res) => { 
      let newUser = Object.assign({}, user)
      newUser.accounts = res.data.accounts
      updateUser(newUser)
    })
  }

  const handleDropDown = (searchKey)  => {
    setAnchorEl(null);
    if (searchKey) {
      setTeamSearch({
        ...teamSearch,
        searchType: searchKey,
      })
    }
  }

  return (
    <Container className={props.className}>
      <Label>
        <Search /> Search
      </Label>
      
      <SearchBar>
        <SelectButton
          label='Email'
          onClick={handleClick}
        />
        <SearchInput
          error={Boolean(error)}
          type="email" 
          autoComplete="email" 
          value={teamSearch.searchTerm}
          onChange={(val) => setTeamSearch({
            ...teamSearch,
            searchTerm: val,
          })}
        />
      </SearchBar>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => handleDropDown(null)}
      >
        <MenuItem onClick={() => handleDropDown('Email')}>Email</MenuItem>
        <MenuItem onClick={() => handleDropDown('Name')}>Name</MenuItem>
      </Menu>

      {error && 
        <ErrorMessage>
          Enter an email or name to search.
        </ErrorMessage>
      }
      <ButtonContainer>
        <ClearButton
          label="Clear"
          onClick={clearSearch}
        />
        {/* <AddButton 
          label="Search"
          onClick={handleSearch}
        /> */}
      </ButtonContainer>
    </Container>
  )
}

export default SearchUser